export default Object.freeze({
  FatherMotherOrManager: 1,
  ParentsLawyer: 2,
  SAEEFunctionary: 6,
});
